"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var lodash_1 = require("lodash");
var theme_1 = require("@shapeable/theme");
var use_theme_1 = require("../../hooks/use-theme");
var DefaultGridProps = {
  className: '',
  columns: 0,
  spacing: 6,
  items: [],
  itemKeys: []
};
// -------- Styles -------->
var GridContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    min-width: 0;\n  "], ["\n    width: 100%;\n    min-width: 0;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-wrap: wrap;\n    display: flex;\n  "], ["\n    flex-wrap: wrap;\n    display: flex;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: wrap;\n    display: flex;\n  "], ["\n    flex-wrap: wrap;\n    display: flex;\n  "])))
});
var oneColumnPatch = function (props) {
  return props.columns === 1 && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-right: none; padding-right: 0; width: 100%;\n"], ["\n  border-right: none; padding-right: 0; width: 100%;\n"])));
};
var calcFor = function (space, columns) {
  // to make the final column align to the end, the width we use isn't just a simple ((100 * 1/n) - space) calc, but rather must dedcut space which would leave (n-1) gutters only. 
  var spaceToDeduct = (columns - 1) / columns * space;
  return "calc(".concat(1 / columns * 100, "% - ").concat(spaceToDeduct, "px)");
};
var GridItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    box-sizing: content-box;\n    padding-bottom: ", ";\n    ", "\n  "], ["\n    box-sizing: content-box;\n    padding-bottom: ", ";\n    ", "\n  "])), function (props) {
    return props.buffer ? 0 : theme_1.theme.UNIT(4);
  }, function (props) {
    return props.borderColor && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), theme_1.theme.COLOR(props.borderColor));
  }),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    border-top: none;\n\n    ", "\n\n\n    ", "\n\n  "], ["\n    border-top: none;\n\n    ", "\n\n\n    ", "\n\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: ", ";\n      padding-bottom: ", ";\n      padding-right: ", ";\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "], ["\n      width: ", ";\n      padding-bottom: ", ";\n      padding-right: ", ";\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "])), calcFor(props.spaceValue, props.columns === 0 ? 2 : props.columns), theme_1.theme.UNIT(props.space), theme_1.theme.UNIT(props.space), props.columns === 0 ? 2 : props.columns, theme_1.theme.UNIT(props.space));
  }, function (props) {
    return props.borderColor && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      border-right: 1px solid ", ";\n      border-bottom: 1px solid ", ";\n      margin-right: -1px;\n\n      &:nth-child(", "n) {\n        border-right: none;\n        margin-right: -", ";\n      }\n\n      ", "\n    "], ["\n      border-right: 1px solid ", ";\n      border-bottom: 1px solid ", ";\n      margin-right: -1px;\n\n      &:nth-child(", "n) {\n        border-right: none;\n        margin-right: -", ";\n      }\n\n      ", "\n    "])), theme_1.theme.COLOR(props.borderColor), theme_1.theme.COLOR(props.borderColor), props.columns === 0 ? 2 : props.columns, theme_1.theme.UNIT(props.space), props.lastRow && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        border-bottom: none;\n      "], ["\n        border-bottom: none;\n      "]))));
  }),
  desktopMid: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n    \n\n    ", "\n    ", ";\n  "], ["\n    ", "\n    \n\n    ", "\n    ", ";\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      width: ", ";\n\n      &:nth-child(2n),\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n    \n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "], ["\n      width: ", ";\n\n      &:nth-child(2n),\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n    \n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "])), calcFor(props.spaceValue, props.columns === 0 ? 3 : props.columns), props.columns === 0 ? 3 : props.columns, theme_1.theme.UNIT(props.space));
  }, function (props) {
    return props.borderColor && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      margin-right: -1px;\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "], ["\n      margin-right: -1px;\n\n      &:nth-child(", "n) {\n        margin-right: -", ";\n      }\n    "])), props.columns === 0 ? Math.min(props.maxColumns || 999, 3) : props.columns, theme_1.theme.UNIT(props.space));
  }, oneColumnPatch),
  desktop4Column: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), calcFor(props.spaceValue, props.columns === 0 ? Math.min(props.maxColumns || 999, 4) : props.columns));
  }),
  desktop5Column: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), calcFor(props.spaceValue, props.columns === 0 ? Math.min(props.maxColumns || 999, 5) : props.columns));
  })
});
// -------- Components -------->
var GridContainer = styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), GridContainerStyles);
var GridItem = styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), GridItemStyles);
var Grid = function (props) {
  var borderColor = props.borderColor,
    className = props.className,
    itemKeys = props.itemKeys,
    columns = props.columns,
    maxColumns = props.maxColumns,
    empty = props.empty,
    spacing = props.spacing;
  var items = (0, lodash_1.filter)(props.items || []);
  // determine size
  var size = columns;
  var themeTokens = (0, use_theme_1.useTheme)();
  if (size === 0) {
    size = items.length % 2 === 0 ? 2 : Math.min(3, Math.max(1, items.length));
  }
  // @ts-ignore
  var Container = GridContainer;
  var spaceUnit = 4;
  var spaceValue = spaceUnit * (spacing || 0);
  var gridItems = items.map(function (item, i) {
    var lastRow = i >= items.length - (columns - items.length % columns);
    return React.createElement(GridItem, {
      maxColumns: maxColumns,
      lastRow: lastRow,
      space: spacing,
      spaceValue: spaceValue,
      columns: columns,
      borderColor: borderColor,
      key: (0, lodash_1.get)(itemKeys, i) || "item".concat(i),
      last: i === items.length - 1
    }, item);
  });
  if (items.length === 0 && Boolean(empty)) {
    return empty;
  }
  ;
  return React.createElement(Container, {
    className: className
  }, gridItems);
};
exports.Grid = Grid;
exports.Grid.defaultProps = DefaultGridProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;